export default {
  ghi_chu: "Note",
  cs_huy_ve: "Cancellation policy",
  cs_nha_xe: "Bus company policy",
  huy_tu: "Cancel time",
  den_truoc: "Come before",
  phi_huy: "Cancellation fee",
  gia_tri_don_hang: "Order value",
  dang_ngay: "Post date",
  sau_khi_dat: "After placing",
  mien_phi: "Free",
  truoc: "Before",
  tieng_truoc_khi_khoi_hanh: "hours before departure time",
  danh_gia: "Evaluate",
  hinh_anh: "Images",
  tien_ich: "Utilities",
  chinh_sach: "Policy",
  gio_khoi_hanh: 'Departure time'
};
